import axiosClient from "api/apiClient";

export interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    subject?: number;
    grade?: number;
}

export const APIPostCustomItemsSubjects = () => {
    return axiosClient.post("/personal-items-disciplines");
}

export const APIPostCustomItemsGrades = () => {
    return axiosClient.post("/personal-items-grades");
}

export const APIGetCustomSubcategories = (options: IOptions) => {
    let sort = "";
    let search = "";
    let subject = "";
    let grade = "";

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }

    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if(options.hasOwnProperty("subject")) {
        subject = "&subject="+ options.subject;
    }

    if(options.hasOwnProperty("grade")) {
        grade = "&grade="+ options.grade;
    }

    return axiosClient.get(`/personal-items-subcategories${options.page}${search}${sort}${subject}${grade}`);
};

export const APIGetCustomSubcategoriesArchived = (options: IOptions) => {
    let sort = "";
    let search = "";
    let subject = "";
    let grade = "";

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }

    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if(options.hasOwnProperty("subject")) {
        subject = "&subject="+ options.subject;
    }

    if(options.hasOwnProperty("grade")) {
        grade = "&grade="+ options.grade;
    }

    return axiosClient.get(`/personal-items-subcategories/archived/${options.page}${search}${sort}${subject}${grade}`);
};